// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__OTe6A","rule":"Pagination_rule__fyBNK","button":"Pagination_button__Hkeg8"};